import { render, staticRenderFns } from "./ProductSectionAssets.vue?vue&type=template&id=2bffcb47&scoped=true"
import script from "./ProductSectionAssets.vue?vue&type=script&lang=js"
export * from "./ProductSectionAssets.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionAssets.vue?vue&type=style&index=0&id=2bffcb47&prod&lang=scss"
import style1 from "./ProductSectionAssets.vue?vue&type=style&index=1&id=2bffcb47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bffcb47",
  null
  
)

export default component.exports